import type { EnterAuth, EnterAuthUser } from '../types';
import { useEnterAuthSession } from './session-provider';

export type { EnterAuth, EnterAuthUser };

/** 暴露业务页面常用的 Auth0 状态，不引入交互式登录副作用。 */
export function useEnterAuth(): EnterAuth {
  const { status, error, isAuthenticated, isLoading, user, loginSessionId } = useEnterAuthSession();
  return { status, error, isAuthenticated, isLoading, user, loginSessionId };
}
